import { useDispatch, useSelector } from "react-redux"
import { json, Link, useParams } from "react-router-dom"
import { Button, Checkbox, CssBaseline, Input, Option, Select, Stack, Textarea } from "@mui/joy";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Grid,
    List,
    ListItem,
    ListItemText,
} from "@mui/joy";
import listaEstados from "./sku_estados";
import { useState } from "react";
import { convertBrazilianDateTimeToJSDate, convertBrazilianDateToJSDate, converterDataParaString, converterDataUSParaBR, convertISOToDate, formatarDataParaString, formatarDataParaStringSemHora, isValidBrazilianDate, isValidBrazilianDateTime, isValidDate, obterDataAtual } from "./livrudo_helpers";
import { novoEstado,salvarEstado, salvarLivro, salvarLivroEditado, salvarSku, trocaEstados } from "./LivrudoSlice";
import { novaConfirmacao, startConfirmacao } from '../helper/confirmation-modal/confirmationSlice';
import { StickyNote2 } from "@mui/icons-material";

function DetalheSkuPage() {

    var dispatch = useDispatch()
    var livros = useSelector((state) => state.livrudo.db.livros)
    var skus = useSelector((state) => state.livrudo.db.skus)
    var estados = useSelector((state) => state.livrudo.db.estados)
    var { id } = useParams()

    var sku = skus.filter(s => s.sku == id)[0]
    var livro = livros.filter(s => s.id == sku.livroId)[0]
    var statuses = estados.filter(s => s.sku == id)

    var [ehCancelavel, setEhCancelavel] = useState(false)


    var [form, setForm] = useState({
        data: formatarDataParaString(obterDataAtual()),
        estado: sku.ultimoEstado,
        observacao: "",
        erro: ""
    })

    var [formObs, setFormObs] = useState(sku.observacao)

    // if(typeof(sku.venda) != "undefined") {

    // delete sku.venda
    // }
    // console.log(sku)

    var cancelar = () => {
        console.log("CAncelando")
        // Cancelar venda
        var novoSku = {...sku}
        delete novoSku.venda
        var e = novoEstado({})
        console.log("CAncelado")
        e.sku = sku.sku
        e.data = converterDataParaString(new Date())
        e.status = "VENDIDO_CANCELADO"
        e.observacao = ""

        var ultimoEstado = statuses.reduce((mostRecent, current) => {
            const mostRecentDate = new Date(mostRecent["data"]);
            const currentDate = new Date(current["data"]);
            return currentDate > mostRecentDate ? current : mostRecent;
        }, { data: "2019-11-29T21:48:00.000Z", status: "COMPRADO_AGUARDANDO_RECEBIMENTO" });

        novoSku.ultimoEstado = new Date(e.data) > new Date(ultimoEstado.data)
            ? e.status : ultimoEstado.status

        dispatch(salvarEstado(e))
        dispatch(salvarSku(novoSku))
    }

    var salvarObs = () => {
        var u = { ...sku, observacao: formObs }
        dispatch(salvarSku(u))
    }

    const vazia = () => {}

    var removeEstado = (id) => {
        var nEstados = [...estados].filter(e => e.id != id)
        var nStatuses = [...statuses].filter(e => e.id != id)
        dispatch(trocaEstados(nEstados))

        var ultimoEstado = nStatuses
            .reduce((mostRecent, current) => {
                const mostRecentDate = new Date(mostRecent["data"]);
                const currentDate = new Date(current["data"]);
                return currentDate > mostRecentDate ? current : mostRecent;
            }, { data: "2019-11-29T21:48:00.000Z", status: "COMPRADO_AGUARDANDO_RECEBIMENTO" })

        var u = { ...sku, ultimoEstado: ultimoEstado.status }
        dispatch(salvarSku(u))
    }

    const [publicacao, setPublicacao] = useState(typeof(sku.publicacao) !== "undefined" ? sku.publicacao : {
        Amazon: { toPublish: false, published: false },
        OLX: { toPublish: false, published: false },
        Enjoei: { toPublish: false, published: false },
        EstanteVirtual: { toPublish: false, published: false },
        MercadoLivre: { toPublish: false, published: false },
        Shopee: { toPublish: false, published: false },
    });

    const platforms = Object.keys(publicacao);

    const handleChangePublicacao = (platform, field) => (event) => {
        setPublicacao((prevState) => ({
            ...prevState,
            [platform]: {
                ...prevState[platform],
                [field]: event.target.checked,
            },
        }));
    };

    const salvarPublicacao = () => {
        var ahPublicar = 0
        var publicado = 0

        platforms.forEach(e => {
            ahPublicar += publicacao[e].toPublish ? 1 : 0
            publicado += publicacao[e].published ? 1 : 0
        })

        var novoSku = { ...sku }
        var e = novoEstado({})
        e.sku = sku.sku
        e.data = converterDataParaString(new Date())
        e.status = false
        e.observacao = ""
        if (ahPublicar > 0) {
            if (publicado == ahPublicar) {
                e.status = "PUBLICADO"
            } else {
                e.status = "ARMAZENADO_A_PUBLICAR"
            }
        } else {
            e.status = "ARMAZENADO"
        }

        novoSku.publicacao = publicacao

        var ultimoEstado = statuses.reduce((mostRecent, current) => {
            const mostRecentDate = new Date(mostRecent["data"]);
            const currentDate = new Date(current["data"]);
            return currentDate > mostRecentDate ? current : mostRecent;
        }, { data: "2019-11-29T21:48:00.000Z", status: "COMPRADO_AGUARDANDO_RECEBIMENTO" });

        novoSku.ultimoEstado = new Date(e.data) > new Date(ultimoEstado.data)
            ? e.status : ultimoEstado.status

        dispatch(salvarEstado(e))
        dispatch(salvarSku(novoSku))
    }

    var cancelarVenda = (sku) => {
        console.log("CAncelando")
        // Cancelar venda
        var novoSku = {...sku}
        delete novoSku.venda
        var e = novoEstado({})
        console.log("CAncelado")
        e.sku = sku.sku
        e.data = converterDataParaString(new Date())
        e.status = "ARMAZENADO"
        e.observacao = ""

        var ultimoEstado = { data: "2019-11-29T21:48:00.000Z", status: "COMPRADO_AGUARDANDO_RECEBIMENTO" };

        novoSku.ultimoEstado = new Date(e.data) > new Date(ultimoEstado.data)
            ? e.status : ultimoEstado.status

        dispatch(salvarEstado(e))
        dispatch(salvarSku(novoSku))
    }

    var fix = () => {
        // Essa funcao serve para alterar problemas nos skus
        // var novoSku = {...sku}
        // var novaVenda = {...novoSku.venda}
        // novaVenda.data = "2025-03-10"
        // novoSku.venda = novaVenda
        // dispatch(salvarSku(novoSku))
        var novoLivro = {...livro}
        novoLivro.nome = novoLivro.nome + " - Prata Prateado";
        console.log(novoLivro); 
        dispatch(salvarLivroEditado(novoLivro));
    }

    var salvar = () => {
        console.log("salvando estado")
        console.log(isValidBrazilianDateTime(form.data))
        if (isValidBrazilianDateTime(form.data)) {
            console.log("Data valida")
            var novoSku = { ...sku }
            var e = novoEstado({})
            var d = convertBrazilianDateTimeToJSDate(form.data)
            e.data = converterDataParaString(d)
            e.sku = sku.sku
            e.status = form.estado
            e.observacao = form.observacao

            var ultimoEstado = statuses.reduce((mostRecent, current) => {
                const mostRecentDate = new Date(mostRecent["data"]);
                const currentDate = new Date(current["data"]);
                return currentDate > mostRecentDate ? current : mostRecent;
            }, { data: "2019-11-29T21:48:00.000Z", status: "COMPRADO_AGUARDANDO_RECEBIMENTO" });

            novoSku.ultimoEstado = new Date(e.data) > new Date(ultimoEstado.data)
                ? form.estado : ultimoEstado.status

            dispatch(salvarEstado(e))
            dispatch(salvarSku(novoSku))
        }
    }

    return (
        <>
            <CssBaseline />
            <Box sx={{ padding: 2, width: "100%" }}>
                <Stack spacing={2}>
                    <Typography level="h2" textAlign="center" mb={2}>
                        Detalhes do Produto
                    </Typography>
                    <Grid container>
                        <Grid xs={12}>
                        <Button color="danger" 
                            disabled={typeof (sku.venda) == "undefined" || sku.venda == null}
                            onClick={() => setEhCancelavel(!ehCancelavel)}>Toggle Cancelavel</Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid xs={3}>
                            <Card variant="outlined" sx={{ padding: 2 }}>
                                <CardContent>
                                    <Typography level="h4" gutterBottom>
                                        Informações Gerais
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Stack>
                                            <Grid xs={12}>
                                                <Typography>Nome:</Typography>
                                                <Typography variant="body2">{livro.nome}</Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>ISBN (SKU):</Typography>
                                                <Typography variant="body2">
                                                    <Link to={"/livrudo/livros/" + livro.id}>
                                                        {livro.isbn}
                                                    </Link>
                                                    ({sku.sku})
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Categoria:</Typography>
                                                <Typography variant="body2">
                                                    {livro.categoria}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Tipo:</Typography>
                                                <Typography variant="body2">
                                                    {livro.tipo}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Último Estado:</Typography>
                                                <Typography variant="body2">
                                                    {sku.ultimoEstado}
                                                </Typography>
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid xs={2}>
                            <Card variant="outlined" sx={{ marginBottom: 4 }}>
                                <CardContent>
                                    <Typography level="h4" gutterBottom>
                                        Compra
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Stack>
                                            <Grid xs={12}>
                                                <Typography>Data:</Typography>
                                                <Typography variant="body2">{sku.data}</Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Condição:</Typography>
                                                <Typography variant="body2">
                                                    {sku.condicao}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Plataforma:</Typography>
                                                <Typography variant="body2">
                                                    {sku.plataforma}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Preço:</Typography>
                                                <Typography variant="body2">
                                                    R$ {sku.preco}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12}>
                                                <Typography>Links:</Typography>
                                               <Stack direction="row" spacing={1}>
                                               {typeof(sku.linkProduto) != "undefined" && sku.linkProduto != null && sku.linkProduto.length > 0 ? <Link to={sku.linkProduto} target="_blank">[Produto]</Link> : <Typography sx={{textDecoration: "line-through"}}>Produto</Typography>}
                                               {typeof(sku.linkCompra) != "undefined" && sku.linkCompra != null && sku.linkCompra.length > 0 ? <Link to={sku.linkCompra} target="_blank">[Compra]</Link> : <Typography sx={{textDecoration: "line-through"}}>Compra</Typography>}
                                               </Stack>
                                            </Grid>
                                            {/* <Grid xs={12}>
                                                <Button onClick={() => fix()} color="danger">Fix</Button>
                                            </Grid> */}
                                        </Stack>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid xs={2}>
                            <Card variant="outlined" sx={{ marginBottom: 4 }}>
                                <CardContent>
                                    <Typography level="h4" gutterBottom>
                                        Venda
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Stack>
                                            {typeof (sku.venda) == "undefined" && sku.venda == null &&
                                                <Grid xs={12}>
                                                    <Link to={"/livrudo/livros/" + livro.id + "/sku/" + sku.sku + "/vender"}>
                                                        <Button color="danger">Vender</Button>
                                                    </Link>
                                                </Grid>}
                                            {typeof (sku.venda) != "undefined" && sku.venda != null && <>
                                                <Grid xs={12}>
                                                    <Typography>Data:</Typography>
                                                    <Typography variant="body2">{sku.venda.data}</Typography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <Typography>Plataforma:</Typography>
                                                    <Typography variant="body2">{sku.venda.plataforma}</Typography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <Typography>Lucro:</Typography>
                                                    <Typography variant="body2">R$ {sku.venda.lucro.toFixed(2)} (R$ {parseFloat(sku.venda.preco).toFixed(2)} - R$ {parseFloat(sku.venda.tarifa).toFixed(2)})</Typography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <Typography>Retorno:</Typography>
                                                    <Typography variant="body2">{((sku.venda.retorno * 100).toFixed(2))}%</Typography>
                                                </Grid>
                                                {ehCancelavel && <Grid xs={12}>
                                                   <Button color="danger" onClick={()=>cancelarVenda(sku)}>Cancelar</Button>
                                                </Grid>}
                                                <Grid xs={12}>
                                                    {/* <Button color="warning" onClick={() => dispatch(startConfirmacao(novaConfirmacao("Deseja cancelar essa venda?", 
                                                        Cancelar
                                                    </Button> */}
                                                </Grid></>} 
                                        </Stack>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid xs={3}>
                            <Card variant="outlined" sx={{ marginBottom: 4 }}>
                                <CardContent>
                                    <Typography level="h4" gutterBottom>
                                        Notas
                                    </Typography>
                                    <Stack spacing={2}>
                                        <Typography>Observação:</Typography>
                                        <Textarea
                                            value={formObs}
                                            onChange={(a) => { setFormObs(a.target.value) }}
                                            placeholder="Escreva sua observação aqui..."
                                            minRows={6}
                                            maxRows={8}
                                            sx={{
                                                width: "100%",
                                            }} />
                                        <Button color="danger" onClick={salvarObs}>Salvar</Button>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid xs={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Stack spacing={2}>
                                        <Stack direction={"row"} spacing={2}>
                                            <Input
                                                type="text"
                                                name="data"
                                                value={form.data}
                                                onChange={(e) => { setForm({ ...form, data: e.target.value }) }}
                                                placeholder="dd/mm/yyyy"
                                            />
                                            <Select
                                                value={form.estado}
                                                onChange={(e, value) => setForm({ ...form, estado: value })}
                                                name="Status">
                                                {listaEstados
                                                    .map(l => <Option value={l}>{l}</Option>)}
                                            </Select>
                                            <Button onClick={salvar}>Salvar</Button>
                                        </Stack>
                                        <Textarea
                                            value={form.observacao}
                                            onChange={(a) => setForm({ ...form, observacao: a.target.value })}
                                            placeholder="Notas..."
                                            minRows="7"></Textarea>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid xs={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    {platforms.map((platform) => (
                                        <Box
                                            key={platform}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                mb: 1,
                                                border: '1px solid #ddd',
                                                borderRadius: 4,
                                                p: 1,
                                            }}
                                        >
                                            <Typography sx={{ flex: 1 }}>{platform}</Typography>
                                            <Checkbox
                                                label="A publicar"
                                                checked={publicacao[platform].toPublish}
                                                onChange={handleChangePublicacao(platform, 'toPublish')}
                                                sx={{ ml: 2 }}
                                            />
                                            <Checkbox
                                                label="Publicado"
                                                checked={publicacao[platform].published}
                                                onChange={handleChangePublicacao(platform, 'published')}
                                                sx={{ ml: 2 }}
                                            />
                                        </Box>
                                    ))}
                                    <Button color="danger" onClick={salvarPublicacao}>Salvar</Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography level="h4" gutterBottom>
                                Estados do Produto
                            </Typography>
                            <List>
                                {statuses.map((estado) => (
                                    <ListItem key={estado.id}>
                                        <Stack direction="row" spacing={1}>
                                            <Box>
                                                <Button onClick={() => removeEstado(estado.id)} color="danger">Excluir</Button>
                                            </Box>
                                            <Box>
                                                <Typography level="body1">
                                                    <strong>Status:</strong> {estado.status}
                                                </Typography>
                                                <Typography level="body2">
                                                    <strong>Data:</strong>{" "}
                                                    {formatarDataParaString(convertISOToDate(estado.data))}
                                                </Typography>
                                                {estado.observacao && (
                                                    <Typography level="body2">
                                                        <strong>Obs:</strong> {estado.observacao}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Stack>
                                    </ListItem>
                                ))}
                            </List>
                        </CardContent>
                    </Card>
                </Stack>
            </Box>
        </>
    );
};

export default DetalheSkuPage

// import React from "react";


// const DetailPage = () => {
//   const produto = {
//     livroId: "ID-24254906",
//     sku: "SKU-83375326",
//     preco: "77.90",
//     data: "2024-09-16",
//     plataforma: "Estante Virtual",
//     linkProduto: "",
//     linkCompra: "",
//     observacao: "",
//     condicao: "USADO_BOM",
//     ultimoEstado: "VENDIDO_AGUARDANDO_SEPARACAO",
//     venda: {
//       preco: "55.00",
//       tarifa: "0.00",
//       plataforma: "OLX",
//       observacao: "Sem tarifa",
//       data: "2024-10-16",
//       lucro: -22.9,
//       retorno: -0.29396662387676514,
//     },
//     status: null,
//   };

//   const livro = {
//     id: "ID-24254906",
//     nome: "D&D 3.0 Master's Guide",
//     isbn: "9780786915514",
//     editora: "Wizards of the Coast",
//     tipo: "CAPA_DURA",
//     categoria: "RPG",
//     data: "16/09/2024 01:16",
//   };

//   const estados = [
//     {
//       id: "81cc992f-59d0-4f3d-bed6-5f4f755fd35f",
//       sku: "SKU-83375326",
//       data: "2024-11-27T04:17:16.820Z",
//       status: "COMPRADO_AGUARDANDO_RECEBIMENTO",
//       obs: "",
//     },
//     // Adicione outros estados aqui
//   ];

//   const detalhesCombinados = { ...produto, ...livro };

//   return (
//     <>
//       <CssBaseline />
//       <Box sx={{ padding: 2 }}>
//         <Typography level="h2" textAlign="center" mb={2}>
//           Detalhes do Produto
//         </Typography>

//         <Card variant="outlined" sx={{ marginBottom: 4 }}>
//           <CardContent>
//             <Typography level="h4" gutterBottom>
//               Informações Gerais
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <Typography>Nome:</Typography>
//                 <Typography variant="body2">{detalhesCombinados.nome}</Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>ISBN:</Typography>
//                 <Typography variant="body2">{detalhesCombinados.isbn}</Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>Preço:</Typography>
//                 <Typography variant="body2">
//                   R$ {detalhesCombinados.preco}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>Categoria:</Typography>
//                 <Typography variant="body2">
//                   {detalhesCombinados.categoria}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>Condição:</Typography>
//                 <Typography variant="body2">
//                   {detalhesCombinados.condicao}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>Último Estado:</Typography>
//                 <Typography variant="body2">
//                   {detalhesCombinados.ultimoEstado}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//         <Card variant="outlined">
//           <CardContent>
//             <Typography level="h4" gutterBottom>
//               Estados do Produto
//             </Typography>
//             <List>
//               {estados.map((estado) => (
//                 <ListItem key={estado.id}>
//                   <ListItemText
//                     primary={`Status: ${estado.status}`}
//                     secondary={`Data: ${new Date(
//                       estado.data
//                     ).toLocaleDateString()}`}
//                   />
//                 </ListItem>
//               ))}
//             </List>
//           </CardContent>
//         </Card>
//       </Box>
//     </>
//   );
// };

// export default DetailPage;
